import {EventEmitter, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EventsEmitterService {
  public languageChange: EventEmitter<string>;
  public authTypeChange: EventEmitter<string>; // client / debtor
  public unreadMailChange: EventEmitter<string>;

  constructor() {
    this.languageChange = new EventEmitter();
    this.authTypeChange = new EventEmitter();
    this.unreadMailChange = new EventEmitter();
  }
}
